import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo-section">
          <img src="/OWS.png" alt="OWS Logo" className="footer-logo" />
          <span className="footer-brand">Odessy Web Services</span>
        </div>
        <p className="text-gray-600 text-sm mb-0">
          © 2026 <span className="footer-brand-text">Odessy Web Services</span>.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
